export const runWhenReady = (fn: () => void): void => {
  setTimeout(fn, 0);
};
